export default __webpack_public_path__ + "static/media/jobs.479496c0.svg";